import { toJS } from 'mobx';

// lodash相关函数部分引入
import _mergeWith from 'lodash/mergeWith';
import _isArray from 'lodash/isArray';
import _merge from 'lodash/merge';
import _set from 'lodash/set';
import { copy } from '@src/slide/infrastructure/module/independent/object-operation';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';

/**
 * 基础样式实现类，包括背景，border边框线 等等
 */
class StyleHandler {
    public static updateUiProps(props: { style: any }, model: IBaseModel) {
        const fn = (modelValue: any, sourceValue: any): any => {
            if (_isArray(modelValue)) { // 数组merge，两者长度要一致，以新数据为准
                const mArrayLen = modelValue.length;
                const sArrayLen = sourceValue.length;
                if (mArrayLen > sArrayLen) {
                    for (let i = 0; i < (mArrayLen - sArrayLen); i++) {
                        modelValue.pop();
                    }
                    const returnV = _merge(modelValue, sourceValue);
                    return returnV;
                }
            }
        };
        // eslint-disable-next-line no-restricted-syntax
        for (const key in props.style) {
            if ({}.hasOwnProperty.call(props.style, key)) {
                const modelObj = model.props.style[key];
                const sourceObj = props.style[key];
                if (modelObj && sourceObj) {
                    // 转成js后再进行merge,否则数据对应不上
                    const newObj = _mergeWith(toJS(modelObj), sourceObj, fn);
                    _set(model.props.style, key, copy(newObj)); // 浅拷贝一份，让对象变更
                } else {
                    _set(model.props.style, key, sourceObj);
                }
            }
        }
    }

    public baseModel?: IBaseModel;

    public constructor(baseModel?: IBaseModel) {
        this.baseModel = baseModel;
    }
}

export default StyleHandler;
